import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-admir-ratings',
  templateUrl: './admir-ratings.component.html',
  styleUrls: ['./admir-ratings.component.css'],
})
export class AdmirRatingsComponent implements OnInit, OnChanges {
  @Input() chilliMax = 3;
  @Input() readOnly = false;
  @Output() RatingChangeCompleteEvent: EventEmitter<any> = new EventEmitter();
  chillMaxArray: any[] = [];
  ratingMaxArray: any[] = [];
  @Input() rating = 0;
  @Input() pathFill = ';';

  constructor() {}

  ngOnInit() {
    if (this.readOnly) {
      this.chillMaxArray = Array(this.chilliMax)
        .fill(null)
        .map((x, i) => i);

      this.ratingMaxArray = Array(this.rating)
        .fill(null)
        .map((x, i) => i);
    } else {
      this.chillMaxArray = Array(this.chilliMax)
        .fill(null)
        .map((x, i) => i);
      // this.chillMaxArray = this.chillMaxArray.map((_, i) => 0 > i);

      this.chillMaxArray = this.chillMaxArray.map((_, i) => this.rating > i);

      this.ratingMaxArray = Array(this.chillMaxArray.length)
        .fill(null)
        .map((x, i) => i);

      // this.RatingChangeCompleteEvent.subscribe((e) => {
      //   console.log("this.rating",this.rating )
      // })
    }
  }

  public rate(rating: number) {
    rating++;
    this.chillMaxArray = this.chillMaxArray.map((_, i) => rating > i);

    this.rating = rating;

    this.ratingMaxArray = Array(this.rating)
      .fill(null)
      .map((x, i) => i);

    const o = Object.assign({}, { time: new Date(), rating: this.rating });
    this.RatingChangeCompleteEvent.emit(o);
  }

  reset() {
    this.chillMaxArray = this.chillMaxArray.map((_, i) => false);
    this.ratingMaxArray = Array(0)
      .fill(null)
      .map((x, i) => i);
    const o = Object.assign({}, { time: new Date(), rating: 0 });
    this.RatingChangeCompleteEvent.emit(o);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.readOnly) {
      return;
    }

    for (const propName in changes) {
      if (propName === 'rating') {
        const chng = changes[propName];
        const cur = JSON.stringify(chng.currentValue);
        const prev = JSON.stringify(chng.previousValue);

        this.rating = parseInt(cur);

        this.chillMaxArray = Array(this.chilliMax)
          .fill(null)
          .map((x, i) => i);

        this.ratingMaxArray = Array(this.rating)
          .fill(null)
          .map((x, i) => i);
      }
    }
  }
}
